import React from 'react';

import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { SimpleSkinsTableRow } from './SimpleSkinsTableRow';
import { ExpandableSkinsTableRow } from './ExpandableSkinsTableRow';

interface IProps {
  hole: string;
  index: number;
  onClick: (index: number) => () => void;
  collapsedRow?: number;
}

export const SkinsTableRow = (props: IProps) => {
  const { hole, index, onClick, collapsedRow } = props;

  const { skinsResults } = useAssignResultsState();

  const holeResults = skinsResults[Number(hole)];

  return holeResults.length === 1 ? (
    <SimpleSkinsTableRow hole={hole} index={index} onClick={onClick} />
  ) : (
    <ExpandableSkinsTableRow
      hole={hole}
      index={index}
      onClick={onClick}
      collapsedRow={collapsedRow}
    />
  );
};
